import { Component } from '@angular/core';

@Component({
  selector: 'app-dynamic-field-checkbox',
  imports: [],
  templateUrl: './dynamic-field-checkbox.html',
  styleUrl: './dynamic-field-checkbox.css'
})
export class DynamicFieldCheckbox {

}
